export function GoPressSection() {
  return (
    <div className="mk-section">
      <div className="mk-container mk-text-center" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <span className="mk-chip">
          <span className="mk-chip-icon">
            <img src="/marketing/go/icons/star-pink.svg" alt="" />
          </span>
          Featured In
        </span>

        <h2 className="mk-title">
          Press <span className="mk-title-accent">Highlights</span>
        </h2>

        <div className="mk-press-card" style={{ textAlign: "left", marginTop: 48 }}>
          <div className="mk-press-stats">
            <div className="mk-press-stat">
              <div className="num pink">84%</div>
              <div className="label">
                Completion Rate
                <br />
                with To To-Do
              </div>
            </div>
            <div className="mk-press-stat">
              <div className="num gray">49%</div>
              <div className="label">
                Completion Rate
                <br />
                with Todoist
              </div>
            </div>
          </div>

          <p className="mk-press-quote">
            &ldquo;I tracked my task completion for five days in Todoist, then
            five days in To To-Do. The Todoist week: 47 tasks created, 23
            completed (49%). The To To-Do week: 31 tasks created, 26 completed
            (84%). To To-Do&rsquo;s simplicity created a kind of accountability
            — if you can&rsquo;t define it clearly enough for a simple list,
            maybe you haven&rsquo;t thought it through yet.&rdquo;
          </p>

          <div className="mk-press-source">
            <img src="/marketing/go/xda-seeklogo-3.svg" alt="XDA Developers" />
            <div>
              <strong>Beatrice Manuel</strong>
              <br />
              <span>XDA Developers - Productivity Expert</span>
            </div>
          </div>

          <div
            style={{
              marginTop: 20,
              paddingTop: 16,
              borderTop: "1px solid rgba(0,0,0,0.08)",
            }}
          >
            <p
              style={{
                fontStyle: "italic",
                fontSize: 14,
                color: "var(--mk-text-secondary)",
                marginBottom: 12,
              }}
            >
              &ldquo;Sometimes the best productivity move isn&rsquo;t finding a
              better app but finding one that gets out of your way. A clean list
              and clear thinking beats a perfectly organized system every
              time.&rdquo;
            </p>
            <a
              href="https://www.xda-developers.com/minimalist-todoist-alternative/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontSize: 14, fontWeight: 500, color: "var(--mk-pink)" }}
            >
              Read full article →
            </a>
          </div>
        </div>

        {/* Secondary quote */}
        <div
          className="mk-press-card"
          style={{ textAlign: "left", marginTop: 16 }}
        >
          <p
            style={{
              fontStyle: "italic",
              marginBottom: 16,
              fontSize: 16,
              lineHeight: 1.6,
            }}
          >
            &ldquo;ToToDo is the counterargument to feature bloat. It&rsquo;s a
            task manager that does exactly one thing: shows you what to do next.
            No color-coding system that requires a legend. Just a chronological
            list of tasks with due dates and a satisfying checkbox.&rdquo;
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 12,
            }}
          >
            <span style={{ fontSize: 13, color: "var(--mk-text-secondary)" }}>
              — Beatrice Manuel, XDA Developers
            </span>
            <a
              href="https://www.xda-developers.com/productivity-app-that-gets-out-of-the-way/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontSize: 14, fontWeight: 500, color: "var(--mk-pink)" }}
            >
              Read article →
            </a>
          </div>
        </div>

        <p
          style={{
            marginTop: 24,
            color: "var(--mk-text-secondary)",
            fontSize: 14,
          }}
        >
          Featured in multiple XDA Developers articles as a minimalist
          alternative that helps users actually finish tasks instead of just
          organizing them.
        </p>
      </div>
    </div>
  )
}
